import React from 'react';
import { C } from 'shared/helpers';
import PropTypes from 'prop-types';

import Styles from './Loading.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default function Loading({ open, loadingSync }) {
  const { Loading, Open, LoadingSync } = Styles;

  return (
    <div className={C(Loading, [open, Open], [loadingSync, LoadingSync])}>
      <div>
        <h1>
          <FontAwesomeIcon size={'3x'} icon={faSpinner} spin />
        </h1>
      </div>
    </div>
  );
}

Loading.propTypes = {
  open: PropTypes.bool.isRequired,
};
